module.exports = __webpack_public_path__ + "img/picture_qgg.317de850.png";